import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { Order } from "../../../objects/orders/order";
import { ModalDirective } from "ngx-bootstrap";
import { OrderOptions } from "../../../objects/orders/orderOptions";
import { OrderHelper } from "../../../common/helpers/orderHelper";
import { BlurUtil } from "../../../common/utils/blurUtil";
import { TaxHelper } from "../../../common/helpers/tax.helper";
import { TaxType } from "../../../objects/orders/taxType";


@Component({
    selector: 'aa-fee-change-modal',
    templateUrl: 'aafee-change-modal.component.html',
    moduleId: module.id.toString()
})
export class AaFeeChangeModalComponent {

    readonly idsToBlur: string[] = ["calculator", "order-id", "order-details"];

    @Input()
    public order: Order;

    @Output()
    public modalHidden: EventEmitter<void> = new EventEmitter<void>();

    @ViewChild('changeConfirmation') public changeConfirmation: ModalDirective;

    public show(): void {
        if(!this.changeConfirmation || !this.changeConfirmation.config){
            this.onModalHidden();
            return;
        }

        if(!OrderHelper.hasOption(this.order, OrderOptions.IsBBFeeEdited)){
            this.onModalHidden();
            return;
        }

        this.changeConfirmation.show();

        this.blurBackContent(this.idsToBlur);
    }

    public onModalHidden(): void {
       setTimeout(() => {
           this.modalHidden.emit();
       })
    }

    public save(resetAaFee: boolean): void {
        if(resetAaFee){
            this.order.Flag &= ~OrderOptions.IsBBFeeEdited;

            this.order.OrderItems.forEach(x=> {
                const aaTax = TaxHelper.getItemTaxOrNull(x, TaxType.AAFee);

                if(aaTax != null){
                    x.Taxes.splice(x.Taxes.indexOf(aaTax), 1);
                }
            });
        }

        this.changeConfirmation.hide();

        this.unblurBackContent(this.idsToBlur);
    }

    public blurBackContent(idNames: string[]){
        for (let idName of idNames){
            BlurUtil.blurMenu(idName);
        }
    }

    public unblurBackContent(idNames: string[]){
        for (let idName of idNames){
            BlurUtil.unBlurMenu(idName);
        }
    }


}


// WEBPACK FOOTER //
// ./app/components/calculator/modals/aafee-change-modal.component.ts